<script setup lang="ts">
/**
 * Dedicated view for `ErrorCode.ClientsByIdsNoClientsFound` (HTTP 403 from the BFF).
 *
 * Unlike `BackendBffError401.vue`, this page does NOT render a "Go To Login"
 * button: failing to resolve client ids is a data / input problem, not an auth
 * problem, so re-authenticating would not change the outcome. The view just
 * surfaces the backend `details` message (forwarded by the axios interceptor
 * as `errorMessage` on the route) with a retry/contact action list, same
 * pattern as `NotFound404.vue`.
 */
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import ErrorView from '@/components/errors/ErrorView.vue'
import { ErrorCode } from '@/errors/codes'
import { ERROR_USER_MESSAGES, errorExplanationFromBackend } from '@/errors/error_user_messages'

const route = useRoute()

const page = ERROR_USER_MESSAGES[ErrorCode.ClientsByIdsNoClientsFound]
const title = page.title
const explanation = computed(() =>
  errorExplanationFromBackend(ErrorCode.ClientsByIdsNoClientsFound, route.query.errorMessage),
)
const actions = page.actions ?? []
</script>

<template>
  <ErrorView
    :code="ErrorCode.ClientsByIdsNoClientsFound"
    :title="title"
    :explanation="explanation"
    :actions="actions"
  />
</template>
